import { useCallback, useState } from "react";

const STORAGE_KEY = "avanto-theme";
type Theme = "light" | "dark";

function resolveInitial(): Theme {
  if (typeof document === "undefined") return "light";
  return (document.documentElement.getAttribute("data-theme") as Theme) ?? "light";
}

export default function useTheme() {
  const [theme, setTheme] = useState<Theme>(resolveInitial);

  const toggle = useCallback(() => {
    const next: Theme = theme === "dark" ? "light" : "dark";
    setTheme(next);
    document.documentElement.setAttribute("data-theme", next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch {}
  }, [theme]);

  return { theme, toggle };
}
